import { lazy } from "react";

const DevisList = lazy(() => import("./DevisList"));
const DevisViewer = lazy(() => import("./DevisViewer"));
const DevisDetails = lazy(() => import("./DevisDetails"));

const devisRoutes = [
  {
    path: "/devis",
    element: <DevisList />,
  },
  {
    path: "/devis/new",
    element: <DevisDetails />,
  },
  {
    path: "/devis/:id",
    element: <DevisViewer />,
  },
];

export default devisRoutes;
